import React from "react";
import NavigationLinks from "./NavigationLinks";
import qiwi from "../assets/img/payment/qiwi 1.png";
import mc from "../assets/img/payment/mc 1.png";
import mir from "../assets/img/payment/mir 1.png";
import sbp from "../assets/img/payment/sbp 1.png";
import visa from "../assets/img/payment/visa 1.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import MyLink from "./MyLink";
import { Link } from "react-router-dom";
import { independentPaths } from "../paths";
import A from "./A";

const Footer = () => {
  return (
    <footer className="center">
      <div>
        <p className="upper-case">Принимаем к оплате</p>
        <div className="payments">
          <LazyLoadImage effect="opacity" src={qiwi} alt="qiwi" />
          <LazyLoadImage effect="opacity" src={sbp} alt="sbp" />
          <LazyLoadImage effect="opacity" src={mir} alt="mir" />
          <LazyLoadImage effect="opacity" src={mc} alt="mc" />
          <LazyLoadImage effect="opacity" src={visa} alt="visa" />
        </div>
        <div className="footer-info">
          <span>© MEGALODON 2024</span>
        </div>
        <div className="text-dark">
          <div className="mega-links d-flex gap-1 justify-center flex-wrap">
            <A href={"https://t.me/Theislemegalodon"}>Telegram</A>
            <A href={"https://discord.gg/megalodon"}>Discord</A>
            <A href={"https://vk.com/theislemegalodon"}>VK</A>
          </div>
          <div className="d-flex gap-1 justify-center flex-wrap">
            <Link to={independentPaths.PrivacyPolicy}>
              Политика конфиденциальности
            </Link>
            <Link to={independentPaths.PublicOffer}>Публичная оферта</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
